import type { SecodaAIProposalOut } from '@repo/api-codegen';
import { trackEvent } from '@repo/common/analytics';
import { useMount } from 'ahooks';
import { useAuthUser } from '../../../../api';
import { ANALYTICS_EVENTS } from '../../constants';
import { DescriptionSuggestionRenderer } from './DescriptionSuggestionRenderer';

import { DocumentSuggestionRenderer } from './DocumentSuggestionRenderer';
import { GlossarySuggestionRenderer } from './GlossarySuggestionRenderer';
import { MonitorCreationRenderer } from './MonitorSuggestionRenderer';

export interface ProposalRendererProps {
	proposal: SecodaAIProposalOut;
}

export function ProposalRenderer({ proposal }: ProposalRendererProps) {
	const { user, workspace } = useAuthUser();

	useMount(() => {
		trackEvent(
			ANALYTICS_EVENTS.AI_SUGGESTION_VIEW,
			{
				proposal_id: proposal.id,
				proposal_type: proposal.data.proposal_type,
			},
			user,
			workspace
		);
	});

	switch (proposal.data.proposal_type) {
		case 'glossary_term_creation':
			return (
				<GlossarySuggestionRenderer data={proposal.data} proposal={proposal} />
			);
		case 'monitor_creation':
			return (
				<MonitorCreationRenderer data={proposal.data} proposal={proposal} />
			);
		case 'description_suggestion':
			return (
				<DescriptionSuggestionRenderer
					data={proposal.data}
					proposal={proposal}
				/>
			);
		case 'document_creation':
			return <DocumentSuggestionRenderer data={proposal.data} />;
		default:
			return <pre>{JSON.stringify(proposal, null, 2)}</pre>;
	}
}
